'use client';

import { ThemeToggle as ChromeThemeToggle } from '@/components/chrome/theme-toggle';
import { trackThemeToggle } from '@/lib/analytics';

/**
 * Theme toggle — thin wrapper around the registry-installed chrome toggle,
 * wiring the site's analytics callback.
 */
export function ThemeToggle() {
  return <ChromeThemeToggle onThemeChange={trackThemeToggle} />;
}
